import moment from 'moment'

const format = 'DD/MM/YYYY hh:mm'
const noTimezoneFormat = 'YYYY-MM-DDTHH:mm'

export function formatGameDate(stringDate) {
  return moment(stringDate, noTimezoneFormat).format(format)
}

export function getCurrentDate() {
  return moment()
}

export function timeElapsedSince(stringStartTime, currentTime) {
  const startTime = moment(stringStartTime, noTimezoneFormat)
  const elapsed = moment.duration(currentTime.diff(startTime))
  return {
    hours: elapsed.days() > 0 ? elapsed.hours() + elapsed.days() * 24 : elapsed.hours(),
    minutes: elapsed.minutes(),
  }
}

export function getFormattedStringDateNow() {
  return moment().format(noTimezoneFormat)
}

export function mergeTimeToDate(date, dateTime) {
  if (date && dateTime) {
    const momentDate = moment(date)
    const momentTime = moment(dateTime)
    momentDate.set({
      'hour': momentTime.get('hour'),
      'minute': momentTime.get('minute'),
    })
    return momentDate.format(noTimezoneFormat)
  }
  return null
}

export function isDate1BeforeDate2(date1, date2, isAsc) {
  if (isAsc) {
    return (moment(date1, ['DD-MM-YYYY HH:mm']) > moment(date2, ['DD-MM-YYYY HH:mm'])) ? 1 : -1
  } else {
    return (moment(date1, ['DD-MM-YYYY HH:mm']) < moment(date2, ['DD-MM-YYYY HH:mm'])) ? 1 : -1
  }

}

export default {
  formatGameDate,
  mergeTimeToDate,
  getFormattedStringDateNow,
  timeElapsedSince,
  getCurrentDate,
  isDate1BeforeDate2,
}
